import React from "react";

class ApInfoInlet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onButtonClick(id) {
    this.props.onButtonClick(id);
  }

  render() {
    return (
      <div
        className="ApInfoInlet"
        style={this.props.small ? { width: "340px" } : {}}
      >
        <p>{this.props.label}</p>
        {this.props.small ? (
          <div>
            <i
              onClick={() => this.onButtonClick("prev")}
              id="OutLeft"
              data-tip="Zurück"
              className="fas fa-backward"
            />
            <i
              onClick={() => this.onButtonClick("next")}
              id="OutRight"
              data-tip="Weiter"
              className="fas fa-forward"
            />
          </div>
        ) : (
          <i
            onClick={() => this.onButtonClick("fullscreen")}
            data-tip="Vollbild"
            className="fas fa-expand-arrows-alt"
          />
        )}
      </div>
    );
  }
}

export default ApInfoInlet;



// WEBPACK FOOTER //
// ./src/components/approval/ApInfoInlet.js